const parentsSpecializationListingManagementRows = [
  {
    id: 1,
    specId: 'UNI-000125', 
     name:'Digital Marketing ', 
    courseName: 'MBA',  
    logo: '/assets/images/university-logo/amity-logo.png',
    university: 'Manipal University Jaipur',
    universityNote: 'Online Manipal',  
    universityId: 'UNI-000125',
    status: 'Live',
    tag: 'Trending',
    createdDate: '02 August 2025',
    lastUpdate:'05 August 2025',
    completion:'90',    
    action: '', 
   
  }, 
  {
    id: 2,
    specId: 'aNI-000125',
     name:'Digital Marketing ',
    courseName: 'MBA',
    logo: '/assets/images/university-logo/amity-logo.png',
    university: 'Manipal University Jaipur',
    universityNote: 'Online Manipal',  
    universityId: 'UNI-100125',
    status: 'Deactivated',
    tag: 'Trending',
    createdDate: '02 August 2025',
    lastUpdate:'05 August 2025',
    completion:'50',    
    action: '', 
   
  },
  {
    id: 3,
    specId: 'sNI-000125',
     name:'Digital Marketing ',
    courseName: 'MBA',
    logo: '/assets/images/university-logo/amity-logo.png',
    university: 'Manipal University Jaipur',
    universityNote: 'Online Manipal',  
    universityId: 'UNI-000125',
    status: 'Draft',
    tag: 'High Demand',
    createdDate: '02 August 2025',
    lastUpdate:'05 August 2025',
    completion:'40',    
    action: '', 
   
  },
  {
    id: 4,
    specId: 'dNI-000125',
     name:'Digital Marketing ',
    courseName: 'MBA',
    logo: '/assets/images/university-logo/amity-logo.png',
    university: 'Manipal University Jaipur',
    universityNote: 'Online Manipal',  
    universityId: 'UNI-000125',
    status: 'Pending',
    tag: 'Top Rated',
    createdDate: '02 August 2025',
    lastUpdate:'05 August 2025',
    completion:'51',    
    action: '', 
   
  },
  {
    id: 5,
    specId: 'UNI-000125',
     name:'Digital Marketing ',
    courseName: 'MBA',
    logo: '/assets/images/university-logo/amity-logo.png',
    university: 'Manipal University Jaipur',
    universityNote: 'Online Manipal',  
    universityId: 'UNI-000125',
    status: 'Live',
    tag: 'Trending',
    createdDate: '02 August 2025',
    lastUpdate:'05 August 2025',
    completion:'70',    
    action: '', 
   
  },
  {
    id: 6,
    specId: 'aNI-000125',
     name:'Digital Marketing ',
    courseName: 'MBA',
    logo: '/assets/images/university-logo/amity-logo.png',
    university: 'Manipal University Jaipur',
    universityNote: 'Online Manipal',  
    universityId: 'UNI-000125',
    status: 'Deactivated',
    tag: 'Trending',
    createdDate: '02 August 2025',
    lastUpdate:'05 August 2025',
    completion:'60',    
    action: '', 
   
  },
  {
    id: 7,
    specId: 'sNI-000125',
     name:'Digital Marketing ',
    courseName: 'MBA',
    logo: '/assets/images/university-logo/amity-logo.png',
    university: 'Manipal University Jaipur',
    universityNote: 'Online Manipal',  
    universityId: 'UNI-000125',
    status: 'Draft',
    tag: 'High Demand',
    createdDate: '02 August 2025',
    lastUpdate:'05 August 2025',
    completion:'90',    
    action: '', 
   
  },
  {
    id: 8,
    specId: 'dNI-000125',
     name:'Digital Marketing ',
    courseName: 'MBA',
    logo: '/assets/images/university-logo/amity-logo.png',
    university: 'Manipal University Jaipur',
    universityNote: 'Online Manipal',  
    universityId: 'UNI-000125',
    status: 'Pending',
    tag: 'Top Rated',
    createdDate: '02 August 2025',
    lastUpdate:'05 August 2025',
    completion:'10',    
    action: '', 
   
  },
  {
    id: 9,
    specId: 'UNI-000125',
     name:'Digital Marketing ',
    courseName: 'MBA',
    logo: '/assets/images/university-logo/amity-logo.png',
    university: 'Manipal University Jaipur',
    universityNote: 'Online Manipal',  
    universityId: 'UNI-000125',
    status: 'Live',
    tag: 'Trending',
    createdDate: '02 August 2025',
    lastUpdate:'05 August 2025',
    completion:'90',    
    action: '', 
   
  },
  {
    id: 10,
    specId: 'aNI-000125',
     name:'Digital Marketing ',
    courseName: 'MBA',
    logo: '/assets/images/university-logo/amity-logo.png',
    university: 'Manipal University Jaipur',
    universityNote: 'Online Manipal',  
    universityId: 'UNI-000125',
    status: 'Deactivated',
    tag: 'Trending',
    createdDate: '02 August 2025',
    lastUpdate:'05 August 2025',
    completion:'90',    
    action: '', 
   
  },
  {
    id: 11,
    specId: 'sNI-000125',
     name:'Digital Marketing ',
    courseName: 'MBA',
    logo: '/assets/images/university-logo/amity-logo.png',
    university: 'Manipal University Jaipur',
    universityNote: 'Online Manipal',  
    universityId: 'UNI-000125',
    status: 'Draft',
    tag: 'High Demand',
    createdDate: '02 August 2025',
    lastUpdate:'05 August 2025',
    completion:'90',    
    action: '', 
   
  },
  {
    id: 12,
    specId: 'dNI-000125',
     name:'Digital Marketing ',
    courseName: 'MBA',
    logo: '/assets/images/university-logo/amity-logo.png',
    university: 'Manipal University Jaipur',
    universityNote: 'Online Manipal',  
    universityId: 'UNI-000125',
    status: 'Pending',
    tag: 'Top Rated',
    createdDate: '02 August 2025',
    lastUpdate:'05 August 2025',
    completion:'90',    
    action: '', 
   
  },
  {
    id: 13,
    specId: 'UNI-000125',
     name:'Digital Marketing ',
    courseName: 'MBA',
    logo: '/assets/images/university-logo/amity-logo.png',
    university: 'Manipal University Jaipur',
    universityNote: 'Online Manipal',  
    universityId: 'UNI-000125',
    status: 'Live',
    tag: 'Trending',
    createdDate: '02 August 2025',
    lastUpdate:'05 August 2025',
    completion:'90',    
    action: '', 
   
  },
  {
    id: 14,
    specId: 'aNI-000125',
     name:'Digital Marketing ',
    courseName: 'MBA',
    logo: '/assets/images/university-logo/amity-logo.png',
    university: 'Manipal University Jaipur',
    universityNote: 'Online Manipal',  
    universityId: 'UNI-000125',
    status: 'Deactivated',
    tag: 'Trending',
    createdDate: '02 August 2025',
    lastUpdate:'05 August 2025',
    completion:'90',    
    action: '', 
   
  },
  {
    id: 15,
    specId: 'sNI-000125',
     name:'Digital Marketing ',
    courseName: 'MBA',
    logo: '/assets/images/university-logo/amity-logo.png',
    university: 'Manipal University Jaipur',
    universityNote: 'Online Manipal',  
    universityId: 'UNI-000125',
    status: 'Draft',
    tag: 'High Demand',
    createdDate: '02 August 2025',
    lastUpdate:'05 August 2025',
    completion:'90',    
    action: '', 
   
  },
  {
    id: 16,
    specId: 'dNI-000125',
     name:'Digital Marketing ',
    courseName: 'MBA',
    logo: '/assets/images/university-logo/amity-logo.png',
    university: 'Manipal University Jaipur',
    universityNote: 'Online Manipal',  
    universityId: 'UNI-000125',
    status: 'Pending',
    tag: 'Top Rated',
    createdDate: '02 August 2025',
    lastUpdate:'05 August 2025',
    completion:'90',    
    action: '', 
   
  },
  {
    id: 17,
    specId: 'UNI-000125',
     name:'Digital Marketing ',
    courseName: 'MBA',
    logo: '/assets/images/university-logo/amity-logo.png',
    university: 'Manipal University Jaipur',
    universityNote: 'Online Manipal',  
    universityId: 'UNI-000125',
    status: 'Live',
    tag: 'Trending',
    createdDate: '02 August 2025',
    lastUpdate:'05 August 2025',
    completion:'90',    
    action: '', 
   
  },
  {
    id: 18,
    specId: 'aNI-000125',
     name:'Digital Marketing ',
    courseName: 'MBA',
    logo: '/assets/images/university-logo/amity-logo.png',
    university: 'Manipal University Jaipur',
    universityNote: 'Online Manipal',  
    universityId: 'UNI-000125',
    status: 'Deactivated',
    tag: 'Trending',
    createdDate: '02 August 2025',
    lastUpdate:'05 August 2025',
    completion:'90',    
    action: '', 
   
  },
  {
    id: 19,
    specId: 'sNI-000125',
     name:'Digital Marketing ',
    courseName: 'MBA',
    logo: '/assets/images/university-logo/amity-logo.png',
    university: 'Manipal University Jaipur',
    universityNote: 'Online Manipal',  
    universityId: 'UNI-000125',
    status: 'Draft',
    tag: 'High Demand',
    createdDate: '02 August 2025',
    lastUpdate:'05 August 2025',
    completion:'90',    
    action: '', 
   
  },
  {
    id: 20,
    specId: 'dNI-000125',
     name:'Digital Marketing ',
    courseName: 'MBA',
    logo: '/assets/images/university-logo/amity-logo.png',
    university: 'Manipal University Jaipur',
    universityNote: 'Online Manipal',  
    universityId: 'UNI-000125',
    status: 'Pending',
    tag: 'Top Rated',
    createdDate: '02 August 2025',
    lastUpdate:'05 August 2025',
    completion:'90',    
    action: '', 
   
  },
];

export default parentsSpecializationListingManagementRows;
